import type { OnChartReady } from './types';

export const onChartReady: OnChartReady = (callback) => {
  const { charts } = window.google;

  charts.load(
    'current',
    {
      packages: [
        'corechart',
      ],
    },
  );
  charts.setOnLoadCallback(callback);
};
